import { render, staticRenderFns } from "./badge-dot.vue?vue&type=template&id=afca0482"
import script from "./badge-dot.vue?vue&type=script&lang=js"
export * from "./badge-dot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports